import { messagesReducer, MessagesState, initialMessagesState } from './messages/messagesReducer'
import {chatFeedReducer, ChatFeedState, initialChatFeedState} from './chatFeed/chatFeedReducer'
import { savedMessagesReducer, SavedMessagesState, initialSavedMessagesState } from './savedMessages';
import { combineReducers } from "redux";

export interface ChatData {
    messages: MessagesState
    chatFeed: ChatFeedState
    savedMessages: SavedMessagesState
}

export const chatDataReducer = combineReducers({
    messages: messagesReducer,
    chatFeed: chatFeedReducer,
    savedMessages: savedMessagesReducer
})

export const initialChatDataState: ChatData = {
    messages: initialMessagesState,
    chatFeed: initialChatFeedState,
    savedMessages: initialSavedMessagesState
}